export const ErrorMessage = {
    SHOWS: "Oops. Something happened!"
}